const createUrlRedirect = (url) => {
	let newUrl = url;
	const queryParams = window.location.search;
	if (queryParams.length > 0) {
		newUrl = `${newUrl}${queryParams}`;
	}

	return newUrl;
};

export default createUrlRedirect;